import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0212 from "../lesson-12/lesson";
import lesson0214 from "../lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "9890020f-7a11-488a-9d85-94b2e0f683d9",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
  {
    id: "780fa82c-ec00-404b-9844-756699ed526b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
];

export default lessonLinks;
